<template>
  <div class="dibubox">
    <van-popup
      v-model="bohao"
      :close-on-click-overlay="false"
      :lock-scroll="false"
    >
      <p style="font-size: 16px">400-800-8772</p>
      <a href="javascript:;" @click="quxiao" class="btn1">取消</a>
      <a href="tel:400-800-8772" class="btn2">拨号</a>
    </van-popup>
    <van-tabbar>
      <van-tabbar-item
      class="bgc1"
        style="background: #F48729; color: #ffffff"
        @click="evaluate"
        >
      <img class="img1" src="../assets/images/Suspended/fangzi.png" alt="">
       <span class="shouye"> <span class="left">首</span><span class="rigth">页</span></span>
        <!-- <div class="shouye"> <div class="shouye11"><span class="left"> 首</span><span class="right">页</span></div></div> -->
        </van-tabbar-item>

      <!-- <van-tabbar-item 
        class="bgc2"
        style="background: #F0552C; color: #ffffff"
        @click="consultation">
        <img class="img2" src="../assets/images/Suspended/shu.png" alt=""> <div class="zhuanye">专业介绍</div></van-tabbar-item >
   
      <van-tabbar-item
        class="bgc3"
        style="background: #FDBE0F; color: #ffffff"
        @click="luquchaxun">
        <img class="img3" src="../assets/images/Suspended/chaxun.png" alt=""> <div class="luqu">录取查询</div> </van-tabbar-item >
    -->
   
       <van-tabbar-item
       class="bgc4"
        style="background: #FDBE0F; color: #ffffff"
        @click="lijizixun">
        <img class="img4" src="../assets/images/Suspended/shejiao.png" alt=""> <div class="zixun">立即咨询</div>
        </van-tabbar-item >

        <van-tabbar-item
        class="bgc5"
        style="background:#F0552C; color: #ffffff"
        @click="DianHua" >
        <img class="img5" src="../assets/images/Suspended/dianhua.png" alt=""> <div class="zaixian">在线报名</div> 
        </van-tabbar-item >
     </van-tabbar>
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";

Vue.use(Notify);
export default {
  data() {
    return {
      bohao: false,
    };
  },

  methods: {
    // 在线报名弹窗
    DianHua() {
      this.bohao = true;
    },
    quxiao() {
      this.bohao = false;
    },
    // 首页
    evaluate() {
       window.location.href ='/'
    },
    // // 专业介绍
    // consultation() {
    //   window.location.href ='http://m.dguedu.com/yingxiangzhizuoxue.html'
    // },
    // // 录取查询
    // luquchaxun(){
    //   window.location.href ='http://m.dguedu.com/luquchaxun.html'
    // },
    // 立即咨询
    lijizixun(){
      window.location.href ='https://tb.53kf.com/code/client/b48a6d9b24a8fba55ca6210e9cad74971/7'
    }
  },
};
</script>

<style  lang="scss" scoped>
.dibubox {
  position: relative;
  z-index: 99999;
  // z-index: 999;
  // position: fixed;
  // height: 100px;
  // bottom: 0px;
  // width: 100%;
  // background: none;
  [class*="van-hairline"]::after {
    position: absolute;
    box-sizing: border-box;
    content: inherit;
    pointer-events: none;
    top: -50%;
    right: -50%;
    bottom: -50%;
    left: -50%;
    border: 0 solid #ebedf0;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }
  .van-tabbar {
    height: 100px;
    .van-tabbar-item {
      height: 100%;
    }
  }
  .van-popup {
    width: 350px;
    height: 194px;
    display: block;
    p {
      margin-top: 44px;
      margin-bottom: 38px;
      color: #666666;
      text-align: center;
      display: block;
    }
    .btn1 {
      box-sizing: border-box;
      height: 50px;
      width: 122px;
      color: #6c6c6c;
      text-align: center;
      box-sizing: border-box;
      font-size: 24px;
      border-radius: 2px;
      display: inline-block;
      text-decoration: none;
      border: 1px solid #666;
      margin-left: 40px;
      background-color: #fff;
      padding-top: 10px;
    }
    .btn2 {
      padding-top: 10px;
      box-sizing: border-box;
      height: 50px;
      width: 122px;
      color: #fff;
      text-align: center;
      box-sizing: border-box;
      margin-left: 26px;
      font-size: 24px;
      border-radius: 2px;
      display: inline-block;
      text-decoration: none;
      background-color: #F48729;
    }
  }
    // 首页
    .bgc1{
        position: relative;
        display: flex;
        .img1{
          width: 28px;
          height: 26px;
          margin-bottom: 8px;
          margin-right: 9px;
          // position: absolute;
          // top: 37px;
          // left: 61px;
        }
    }
    .shouye{
      width: 85px;
      height: 23px;
      font-size: 25px;
      
     
        .left{
        // float: left;
        padding-right: 20px;
        padding-left: 10px;
      }
      // .right{
      //   float: right;
      // }
      
    }
    // // 专业
    // .bgc2{
    //     position: relative;
    //     .img2{
    //       width: 31px;
    //       height: 27px;
    //       position: absolute;
    //       top: 20px;
    //       left: 61px;
    //     }
    // }
    // .zhuanye{
    //   // width: 100px;
    //   height: 24px;
    //   font-size: 25px;
    //   margin-top: 49px;
    // }
    // 录取
    // .bgc3{
    //     position: relative;
    //     .img3{
    //       width: 29px;
    //       height: 27px;
    //       position: absolute;
    //       top: 20px;
    //       left: 61px;
    //     }
    // }
    // .luqu{
    //     // width: 100px;
    //   height: 24px;
    //   font-size: 25px;
    //   margin-top: 49px;
    // }
    //咨询
    .bgc4{
        position: relative;
        .img4{
          width: 30px;
          height: 27px;
          // position: absolute;
          // top: 20px;
          // left: 61px;
          margin-right: 9px;

        }
    }
    .zixun{
      display: inline;
        // width: 100px;
      height: 24px;
      font-size: 25px;
      // margin-top: 49px;
    }
    //在线
    .bgc5{
        position: relative;
        .img5{
          width: 28px;
          height: 28px;
          // position: absolute;
          // top: 20px;
          // left: 61px;
          margin-right: 9px;
        }
    }
    .zaixian{
      display: inline;
        // width: 100px;
      height: 24px;
      font-size: 25px;
      // margin-top: 49px;
    }
}
</style>